import {
  CopyableText,
  formatDate,
  formatNumber,
  Separator,
} from '@acme/foundation';
import { Badge } from 'flowbite-react';
import { Link } from 'react-router-dom';
import { AppRoutes } from '@shared/routes';

export type WalletCardProps = {
  application: { name: string; id: string };
  expiredData: string;
  walletAddress: string;
  balance: number;
  token: string;
};

export const WalletCard = (props: WalletCardProps) => {
  const isActiveWallet = Date.now() < new Date(props.expiredData).getTime();

  return (
    <div className="rounded-lg bg-gray-50 border border-gray-200 border-solid p-4 flex flex-col gap-3 text-gray-500">
      <div className="flex justify-between gap-1 text-xs font-medium">
        {isActiveWallet ? (
          <>
            <span>Действителен до: {formatDate(props.expiredData)}</span>
            <Badge color="lightGreen">Активен</Badge>
          </>
        ) : (
          <>
            <span className="text-red-600">Истекло время хранения</span>
            <Badge color="red">Продажа</Badge>
          </>
        )}
      </div>

      <div className="flex flex-col gap-4">
        <Separator />

        <div className="flex items-center gap-2">
          <p className="truncate">{props.walletAddress}</p>

          <CopyableText
            value={props.walletAddress}
            className="items-center"
            label=""
            classNameButton="bg-white border border-gray-200 text-gray-900 hover:text-gray-500 hover:bg-white"
          />
        </div>

        <div className="flex gap-3 items-center">
          <span className="text-lg font-semibold">{props.token}</span>

          <span className="font-bold text-2xl text-gray-900">
            {formatNumber(props.balance)}
          </span>
        </div>

        <Separator />
      </div>

      <div className="flex items-center gap-1">
        <span>Заявка:</span>
        <Link
          to={AppRoutes.application.getPath?.(props.application.id) as string}
          className="text-primary-600 font-semibold"
        >
          {props.application.name}
        </Link>
      </div>
    </div>
  );
};
